@if (opened()) {
  <div class="preview-overlay" tabindex="0" (click)="close()" (keydown.escape)="close()">
    <div class="preview-container" role="dialog" aria-modal="true" tabindex="0" (click)="$event.stopPropagation()" (keydown.escape)="close()">
      <button class="close-btn" type="button" aria-label="Close preview" (click)="close()">
        <sxw-svg-icon name="cross" width="16" height="16" strokeColor="rgba(255, 255, 255, 0.92)"></sxw-svg-icon>
      </button>

      <!-- Stage -->
      <div class="preview-stage">
        @if (isLoading()) {
          <div class="loading-layer">
            <div class="skeleton"></div>
            <div class="spinner"></div>
          </div>
        }

        @if (loadError()) {
          <div class="error-layer">
            <div class="error-card">
              <sxw-svg-icon name="cross" width="24" height="24" strokeColor="var(--p-red-400)"></sxw-svg-icon>
              <p class="error-card__message">{{ "FILES_PREVIEW.PDF_ERROR" | translate }}</p>
              <button type="button" class="tool-btn" (click)="retryLoad()">
                {{ "FILES_PREVIEW.RETRY" | translate }}
              </button>
            </div>
          </div>
        }

        @if (safeSrc(); as pdfSrc) {
          <iframe class="preview-iframe" [src]="pdfSrc" title="PDF Preview"></iframe>
        }
      </div>
    </div>
  </div>
}
